import { useEffect, useState } from "react";
import { ScanSearch } from "lucide-react";
import { trackEvent } from "@/lib/audit";

interface FrameLike {
  ball: { x: number; y: number };
  inDanger: boolean;
  freeKick?: boolean;
}

type VarState = {
  active: boolean;
  reason: string;
  decision: string;
};

function inferVar(frame: FrameLike, t: number): VarState {
  // Simulated VAR rules. Editorial language, no certainties.
  const inBox = frame.ball.x > 32 && Math.abs(frame.ball.y) < 20;
  if (frame.freeKick) return { active: true, reason: "Falta en zona ofensiva", decision: "Decisión probable: tiro libre" };
  if (inBox && (Math.floor(t) % 17) === 0) return { active: true, reason: "Contacto en el área", decision: "Posible revisión de penal" };
  if (frame.ball.x > 38 && (Math.floor(t) % 11) === 0) return { active: true, reason: "Pase en profundidad", decision: "Posible fuera de juego" };
  return { active: false, reason: "Sin revisión activa", decision: "Juego en desarrollo" };
}

export function VarWidget({ frame, elapsed }: { frame: FrameLike; elapsed: number }) {
  const state = inferVar(frame, elapsed);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    if (state.active && !seen) {
      setSeen(true);
      void trackEvent("var_widget_viewed", { reason: state.reason });
    }
  }, [state.active, state.reason, seen]);

  return (
    <div className="rounded-xl border border-border/60 glass p-2.5">
      <div className="mb-1 flex items-center justify-between text-[9px] font-bold tracking-widest text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <ScanSearch className="h-3 w-3" />
          VAR · REVISIÓN TÁCTICA
        </span>
        <span
          className={`flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[8.5px] ${
            state.active
              ? "bg-[oklch(0.78_0.2_60)]/15 text-[oklch(0.78_0.2_60)]"
              : "bg-muted/40 text-muted-foreground"
          }`}
        >
          <span className={`h-1.5 w-1.5 rounded-full ${state.active ? "bg-[oklch(0.78_0.2_60)] animate-pulse-dot" : "bg-muted-foreground/60"}`} />
          {state.active ? "ACTIVA" : "EN ESPERA"}
        </span>
      </div>
      <div className="text-[11px] font-bold leading-tight">{state.reason}</div>
      <div className="text-[10px] text-muted-foreground">{state.decision}</div>
    </div>
  );
}